import React, { useState } from "react";
import axios from "axios";
import { config as axiosConfig } from "../shared/config";

const AssociateBots = () => {
  const [updating, setUpdating] = useState(false);

  const updateAssociateBots = async () => {
    let auth;

    if (typeof window !== "undefined") {
      auth = JSON.parse(localStorage.getItem("auth")).data;
    }

    const page = prompt("Enter the page number");

    setUpdating(true);
    try {
      const res = await axios.post(
        `${axiosConfig.baseUrl}/bot/update-associate-bots?page=${page}`,
        {},
        {
          headers: {
            Authorization: auth?.accessToken,
          },
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <span
      onClick={updateAssociateBots}
      className="flex px-3 py-2 items-center justify-center gap-2 h-full !border !border-purple-600 text-purple-600 cursor-pointer mx-2"
    >
      {updating ? "Updating..." : "Update Associate Bots"}
    </span>
  );
};

export default AssociateBots;

